import React from "react";
import { Link } from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
    {
        image: "/images/embres/consulting.jpg",
        title: "Definition von Anforderungen",
        description: "kostenoptimierte Anforderungen",
    },
    {
        image: "/images/embres/schematic.jpg",
        title: "Erstellung Stromlaufplan",
        description: "abgestimmte SLP-Entwicklung",
    },
    {
        image: "/images/embres/layout.jpg",
        title: "Erstellung Layout",
        description: "uC bis PC-Mainboard Design",
    },
    {
        image: "/images/embres/pcb-assy.jpg",
        title: "Serien-Bestückung",
        description: "Bestückung von Protoypen und Kleinserien",
    },
    {
        image: "/images/embres/cnc.jpg",
        title: "Gehäusebearbeitung ",
        description: "CNC-Fräsen, 3D-Druck FDM/STL",
    },
    {
        image: "/images/embres/software.jpg",
        title: "embedded / UI / UX Software",
        description: "VHDL/Verilog, C/C++, python, Qt, flutter, react",
    },
];
const ServiceFive = ({ textAlign, serviceStyle }) => {
    return (
        <div className="row row--15 service-wrapper">
            {ServiceList.map((val, i) => (
                <div className="col-lg-4 col-md-6 col-sm-12 col-12" key={i}>
                    <ScrollAnimation animateIn="fadeInUp" animateOut="fadeInOut" animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="inner">
                                <div className="content">
                                    <h4 className="title">
                                        <Link to="#service" dangerouslySetInnerHTML={{ __html: val.title }}></Link>
                                    </h4>
                                    <p className="description" dangerouslySetInnerHTML={{ __html: val.description }}></p>
                                </div>
                                <div className="image">
                                    <img src={`${val.image}`} alt="card Images" />
                                </div>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    );
};
export default ServiceFive;
